import { createStyles, makeStyles, Theme } from '@material-ui/core'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      width: '100%',
    },
    navigation: {
      width: '100%',
      color: theme.customColors.info,
      background: theme.palette.primary[theme.palette.type],
      height: '6em',
      flexDirection: 'column',
      [theme.breakpoints.up('tablet')]: {
        height: '9em',
        flexDirection: 'row',
      },
      display: 'flex',
      justifyContent: 'space-between',
    },
    navigationInfo: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      width: '100%',
    },
    logo: {
      maxWidth: '100%',
      maxHeight: '100%',
      objectFit: 'contain',
    },
    branding: {
      textAlign: 'center',
      width: '90%',
      display: 'inline-block'
    },
    info: {
      paddingLeft: '1em',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      width: '100%',
      [theme.breakpoints.up('tablet')]: {
        padding: '1em',
      },
    },
    navigationBar: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'flex-end',
      background: 'yellow',
    },
    logoContainer: {
      cursor: 'pointer',
      padding: '0.7em',
      backgroundColor: 'white',
      width: '14em',
      display: 'flex',
      justifyContent: 'center',
      height: '6em',
      [theme.breakpoints.up('tablet')]: {
        height: '9em',
      },
    },
  })
)
